import React, { useEffect } from 'react';
import { CommonHeader, Loader } from '../../../components/commons';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import {
  getClientOpenItemsListAction,
  resetClientOpenItemsList,
  resetOpenItemsError,
  resetOpenItemsSuccess
} from '../../../redux/openItems';
import { GetClientOpenItemsListingPayload } from '../../../commonTypes/openItemsTypes';
import { UserIcon } from '../../../components/Icon';
import { EmptyDocumentData } from '../../../components/OpenItems';
import { EmptyList } from '../../../assets/images';
import ClientListTable from '../../../components/OpenItems/Client/ClientListTable';
import { CLIENT_OPEN_ITEM_HEADERS } from '../../../constant/tableHeadersConstants/openItemsHeadersConst';
import { useMenuCheck } from '../../../customHooks/useMenuCheck';

type AppProps = {
  fetching: boolean;
  history?: any;
  error: string | null;
  token: string | null;
  clientOpenItemList: any | null;
  dispatchGetClientOpenItemsList: (data: GetClientOpenItemsListingPayload) => void;
  dispatchResetOpenItemsError: () => void;
  dispatchResetOpenItemsSuccess: () => void;
  dispatchResetClientOpenItemsList: () => void;
}

const ClientOpenItemsList = ({
  fetching,
  history,
  token,
  clientOpenItemList,
  dispatchGetClientOpenItemsList,
  dispatchResetOpenItemsError,
  dispatchResetOpenItemsSuccess,
  dispatchResetClientOpenItemsList,
}: AppProps) => {

  const client_code: number = history?.location?.state?.client_code;
  const company_name: string = history?.location?.state?.company_name;

  //===============================User Management=================================
  const [isViewOpenItemClientPresent,setIsViewOpenItemClientPresent]=useMenuCheck()
  //===============================================================================

  useEffect(() => {
    if (token) {
      let data = {
        client_code,
        offset: 0,
        limit: 10,
        token
      }
      dispatchResetClientOpenItemsList();
      dispatchResetOpenItemsError();
      dispatchResetOpenItemsSuccess();
      dispatchGetClientOpenItemsList(data);
      setIsViewOpenItemClientPresent("View Open Item client","menu")
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchNewData = (offset?: number, limit?: number, search?: string) => {
    if (token) {

    

      let finalData = {
        token,
        client_code,
        offset: offset || 0,
        limit: limit || 10
      }
      dispatchGetClientOpenItemsList(finalData);
    }
    dispatchResetOpenItemsError();
    dispatchResetOpenItemsSuccess();
  }

  const handleRedirectToViewOpenItem = (jobId: number | null) => {
    history.push({pathname:`/open-items-client/${ client_code }/view/${ jobId }`,state:{client_code,company_name}})
  }

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="Open Items" />
        <div className="d-flex align-items-center">
          {client_code ? <>
            <UserIcon /> &nbsp;
            {company_name}  {"(" + client_code + ")"}</> : null}
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div className="content-area">
          {
            clientOpenItemList?.count === 0 ? <EmptyDocumentData
              heading="Hooray! No open items here."
              imageWidth="35%"
              image={EmptyList}
            /> : <ClientListTable
              data={clientOpenItemList?.data}
              count={clientOpenItemList?.count}
              client_code={client_code}
              history={history}
              tableHeader={CLIENT_OPEN_ITEM_HEADERS}
              fetchNewData={fetchNewData}
              handleRedirectToViewOpenItem={handleRedirectToViewOpenItem}
              isViewOpenItemClientPresent={isViewOpenItemClientPresent}
            />
          }
        </div>
      </div>
      {fetching && <Loader />}
    </div>
  )
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.openItems.fetching,
  error: state.openItems.error,
  clientOpenItemList: state.openItems.clientOpenItemList
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetClientOpenItemsList: (data: GetClientOpenItemsListingPayload) =>
    dispatch(getClientOpenItemsListAction(data)),
  dispatchResetOpenItemsError: () => dispatch(resetOpenItemsError()),
  dispatchResetOpenItemsSuccess: () => dispatch(resetOpenItemsSuccess()),
  dispatchResetClientOpenItemsList: () => dispatch(resetClientOpenItemsList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientOpenItemsList);